/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
import { sprayAt } from './sprayAlgorithms.basic.js';
import { sprayAt10cm } from './sprayAlgorithms.small.js';
import { sprayWithRoller } from './sprayAlgorithms.roller.js';
import { sprayNYFat } from './sprayAlgorithms.ny_fat.js';
export default function createEventHandlers({
  state,
  canvasManager,
  ui,
  notifications,
  paintSystem,
  presetManager
}) {
  const canvas = canvasManager.canvas;
  const ctx = canvasManager.ctx;
  const scaleRange = document.getElementById('scaleRange');
  const radiusRange = document.getElementById('radiusRange');
  const densityRange = document.getElementById('densityRange');
  const speedFactorInput = document.getElementById('speedFactor');
  const resetBtn = document.getElementById('resetBtn');
  const controlsPanel = document.getElementById('controls-panel');
  function handleStart(e) {
    e.preventDefault();
    const activeCan = state.cansData.find(c => c.id === state.config.activeCanId);
    if (!activeCan || activeCan.paintLeft <= 0) {
      notifications.showPaintEmptyToast(state.config.activeCanId);
      return;
    }
    const { x, y } = canvasManager.getCanvasCoords(e);
    state.isDrawing = true;
    window.isLocalDrawing = true;
    state.lastStaticSprayPos = null;
    state.staticSprayStartTime = null;
    const isRollerPreset = (activeCan && activeCan.type === 'roller') || (state.currentPreset && state.currentPreset.includes('Roller')) || state.currentPreset === 'Roll';
    const brushRadius = isRollerPreset ? 150 : (state.config.sprayRadius * state.config.lineScale * 6);
    state.markDirtyRegion(x, y, brushRadius);
    if (isRollerPreset) {
      sprayWithRoller(x, y, {
        state,
        canvas: canvasManager,
        notifications
      });
    } else if (state.currentPreset === 'Small') {
      sprayAt10cm(x, y, {
        state,
        canvas: canvasManager,
        notifications
      });
    } else if (state.currentPreset === 'ny_fat') {
      sprayNYFat(x, y, {
        state,
        canvas: canvasManager,
        notifications
      });
    } else {
      sprayAt(x, y, {
        state,
        canvas: canvasManager,
        notifications
      });
    }
    ui.updateCursor(e);
    if (typeof window.onSprayStroke === 'function') window.onSprayStroke();
  }
  function handleMove(e) {
    if (!state.isDrawing) return;
    e.preventDefault();
    const { x, y } = canvasManager.getCanvasCoords(e);
    const activeCan = state.cansData.find(c => c.id === state.config.activeCanId);
    const isRollerPreset = (activeCan && activeCan.type === 'roller') || (state.currentPreset && state.currentPreset.includes('Roller')) || state.currentPreset === 'Roll';
    const brushRadius = isRollerPreset ? 150 : (state.config.sprayRadius * state.config.lineScale * 6);
    state.markDirtyRegion(x, y, brushRadius);
    if (isRollerPreset) {
      sprayWithRoller(x, y, { state, canvas: canvasManager, notifications });
    } else if (state.currentPreset === 'Small') {
      sprayAt10cm(x, y, { state, canvas: canvasManager, notifications });
    } else if (state.currentPreset === 'ny_fat') {
      sprayNYFat(x, y, { state, canvas: canvasManager, notifications });
    } else {
      sprayAt(x, y, { state, canvas: canvasManager, notifications });
    }
    ui.updateCursor(e);
    if (typeof window.onSprayStroke === 'function') window.onSprayStroke();
  }
  function handleEnd() {
    const wasDrawing = state.isDrawing;
    state.isDrawing = false;
    window.isLocalDrawing = false;
    const customCursor = document.getElementById('customCursor');
    if (customCursor) {
      customCursor.style.display = 'none';
    }
    state.lastSprayPos = null;
    state.lastSprayTime = null;
    state.lastStaticSprayPos = null;
    state.staticSprayStartTime = null;
    state.isStaticSpraying = false;
    if (wasDrawing && typeof window.onSprayEnd === 'function') {
      const dirtyArray = Array.from(state.dirtyChunks);
      window.onSprayEnd(dirtyArray);
      state.dirtyChunks.clear();
    }
  }
  if (canvas) {
    ['touchstart', 'mousedown'].forEach(type =>
      canvas.addEventListener(type, handleStart, { passive: false })
    );
  }
  if (canvas) {
    ['touchmove', 'mousemove'].forEach(type =>
      canvas.addEventListener(type, handleMove, { passive: false })
    );
  }
  if (canvas) {
    ['touchend', 'mouseup', 'mouseleave'].forEach(type =>
      canvas.addEventListener(type, handleEnd)
    );
    canvas.addEventListener('click', () => {
    });
  }
  if (scaleRange) {
    scaleRange.addEventListener('input', (e) => {
      const newValue = parseFloat(e.target.value);
      state.config.lineScale = newValue;
      state.dynamicSpeed = newValue;
      ui.updateUI();
    });
  }
  if (radiusRange) {
    radiusRange.addEventListener('input', (e) => {
      const newValue = parseInt(e.target.value);
      state.config.sprayRadius = newValue;
      state.dynamicRadius = newValue;
      ui.updateUI();
    });
  }
  if (densityRange) {
    densityRange.addEventListener('input', (e) => {
      const newValue = parseInt(e.target.value);
      if (newValue < 50) return;
      state.config.dotsPerTick = newValue;
      state.dynamicDensity = newValue;
      ui.updateUI();
    });
  }
  if (speedFactorInput) {
    speedFactorInput.addEventListener('input', (e) => {
      const newValue = parseFloat(e.target.value);
      state.config.speedFactor = newValue;
      state.dynamicSpeedFactor = newValue;
      ui.updateUI();
    });
  }
  const clearCanvas = () => {
    state.paintedPixels.clear();
    for (let key in state.dripMap) delete state.dripMap[key];
    for (let key in state.staticSprayMap) delete state.staticSprayMap[key];
    state.lastSprayPos = null;
    state.lastSprayTime = null;
    state.lastStaticSprayPos = null;
    state.staticSprayStartTime = null;
    state.isStaticSpraying = false;
    state.shownPaintEmptyAlerts.clear();
    if (ctx && canvas) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    ui.updateUI();
  };
  const handleRemotePoint = ({ x, y, radius, density, scale, speedFactor, color, preset, tool }) => {
    const remoteState = {
      ...state,
      config: {
        ...state.config,
        sprayRadius: radius,
        dotsPerTick: density,
        lineScale: scale,
        speedFactor: speedFactor,
        currentColor: color
      },
      currentPreset: preset,
      isDrawing: true,
      isPreview: true,
    };
    remoteState.updateCanPaint = () => {};
    state.markDirtyRegion(x, y, radius * scale * 6);
    const context = {
        state: remoteState,
        canvas: canvasManager,
        notifications: { showToast: () => {}, showPaintEmptyToast: () => {} }
    };
    if (tool === 'roller') {
      sprayWithRoller(x, y, context);
    } else if (preset === 'Small') {
      sprayAt10cm(x, y, context);
    } else if (preset === 'ny_fat') {
      sprayNYFat(x, y, context);
    } else {
      sprayAt(x, y, context);
    }
  };
  return {
    clearCanvas,
    handleRemotePoint,
    destroy: () => {
    }
  };
}
